/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useLocation } from "react-router-dom";

export const useTitle = () => {
  const location = useLocation();

  const checkIsAtHome = location.pathname === "/";

  const path = !checkIsAtHome
    ? location.pathname
        .split("/")
        .filter((item) => item !== "")
        .reduce((acc: string[], b: string) => [b, ...acc], [])[0]
    : "";

  const split = path.split("");
  const hasDash = split.filter((item) => item === "-").length !== 0;

  const replaceDash = hasDash ? path.replace("-", " ") : path;

  const makeCapitalize =
    replaceDash.charAt(0).toUpperCase() + replaceDash.slice(1);

  React.useEffect(() => {
    document.title = `Overlay | ${makeCapitalize}`;
  }, [makeCapitalize]);
};
